import config from '../../infra/config';
const HOST = config.KEYWORDS_SUGGESTIONS_API;

export default {
  getSuggestedKeywords: (text) => ({ url: `${HOST}/api/0.2/suggest?txt=${text}` }),
};
